import { useContext } from 'react'
import { AppConfigContext } from '../contexts/app-config.context'
import { formatInTimeZone } from 'date-fns-tz'
import { getClientTimeZone } from '../helpers/timezone.helper'

type ConvertDateOptionsType = {
    format: string
    timeZone: string
    hideTime: boolean
}

export const useDateConverter = () => {
    const appConfigStore = useContext(AppConfigContext)
    const userTimeZone = appConfigStore.timezone
    const defaultReturnValue = ''
    const defaultOptions: ConvertDateOptionsType = {
        format: 'LLL dd, yyyy hh:mm a',
        timeZone: userTimeZone ?? getClientTimeZone(),
        hideTime: false,
    }

    const convertDateStringToFormat = (
        date: Date | string,
        convertDateOptions: Partial<ConvertDateOptionsType> = defaultOptions
    ): string => {
        try {
            let dateToBeConverted: Date

            if (date == null || date == undefined) {
                return defaultReturnValue
            }
            if (!(date instanceof Date) && typeof date != 'string') {
                return defaultReturnValue
            }

            dateToBeConverted = new Date(date)
            if (Number.isNaN(dateToBeConverted.getDate())) {
                return defaultReturnValue
            }

            if (defaultOptions.hideTime) {
                convertDateOptions.format = 'LLL dd, yyyy'
            } else {
                convertDateOptions.format = 'LLL dd, yyyy hh:mm a'
            }

            return formatInTimeZone(
                date,
                convertDateOptions.timeZone ?? defaultOptions.timeZone,
                convertDateOptions.format ?? defaultOptions.format
            )
            }  catch (error) {
                console.warn('Date conversion error:', error, 'for date:', date);
                return defaultReturnValue
            }
        }
        return { convertDateStringToFormat }
    }
